import { ApolloClient } from '@apollo/client'
import React, { useContext } from 'react'
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom'
import { useLocation } from 'react-router'
import { isMfaPending, StateStore } from '../../containers/StoreProvider'


interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>
  authenticated: boolean
  client?: ApolloClient
}

type RenderComponent = (props: RouteComponentProps) => React.ReactNode

const PrivateRoute: React.FC<PrivateRouteProps> = ({ authenticated, component: Component, ...rest }) => {
  const { state } = useContext(StateStore)
  const location = useLocation()

  if (!authenticated || !state.currentUser) {
    return <Redirect to="/login" />
  }

  const mfaPending = isMfaPending(state.currentUser)

  if (mfaPending && location.pathname !== '/mfa') {
    return <Redirect to={`/mfa`} />
  }

  if (!mfaPending && location.pathname === '/mfa') {
    return <Redirect to="/towing-jobs" />
  }

  const renderComponent: RenderComponent = props => <Component {...props} />
  return <Route {...rest} render={renderComponent} />
}

export default PrivateRoute
